import Button from 'jd-library/Button';
import historyHandler from 'jd-library/historyHandler';
import withPortal from "jd-library/withPortal";
import Modal from 'jd-library/Modal';
import React from 'react';
import styles from './Styles/shadow-batch-modal.scss'

const ShadowBatchModal = (props )=> {
	return (
		<Modal
			settings={{
				modalId: 'ShadowBatch',
				variant: 'action',
				class: `${styles['shadow-batch-modal']}`,
			}}
			backdropStatic={true}
			onHidden={props.onHidden}
			
		>
			<div className={styles['shadow-required-body']}>
				<div
					className={`${styles['shadow-required-message']} `}
				>
					Please approve this product before updating inventory.
				</div>
			</div>
			<div className={styles['shadow-pending-btn']}>
				<Button
					size='lg'
					block
					clickHandler={() => {
						historyHandler.closeAll();
					}}
				>
					{'Okay, Got it'}
				</Button>
			</div>
		</Modal>
	);
};

export default withPortal(ShadowBatchModal);